import React from 'react';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';


const SliderCode = () => {

    return (
        <>
            <div class="slider">
                <div class="slides">
                    <div class="slide slide1">
                        <img src='/mainimage/sliderimage.png' />
                    </div>
                    <div class="slide slide3">
                        <img src='/mainimage/sliderimage.png' />
                    </div>
                    <div class="slide slide2">
                        <img src='/mainimage/sliderimage2.png' />
                    </div>
                </div>
            </div>
        </>
    )
};

export default SliderCode;